// extracted by mini-css-extract-plugin
export var contactConfirmButtons = "contactez-nous-module--contact-confirm-buttons--daf81";
export var contactConfirmContainer = "contactez-nous-module--contact-confirm-container--af141";
export var contactConfirmMessage = "contactez-nous-module--contact-confirm-message--fa6ee";
export var contactContainer = "contactez-nous-module--contact-container--990eb";
export var contactFormTitle = "contactez-nous-module--contact-form-title--7a393";
export var inputContactForm = "contactez-nous-module--input-contact-form--a90e3";
export var textLabel = "contactez-nous-module--text-label--08e00";